import { useIsUsingBigBlocks } from '@/domain/hooks/useIsUsingBigBlocks'
import { useBigBlocksToggle } from '@/features/swap/logic/useBigBlocksToggle'
import { Button } from '@/ui/atoms/button/Button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/ui/atoms/dropdown/DropdownMenu'
import { Typography } from '@/ui/atoms/typography/Typography'
import { SettingsButton } from '@/ui/molecules/settings-button/SettingsButton'
import { Loader2 } from 'lucide-react'
import { useState } from 'react'

export function SettingsPopOver() {
  const [isOpen, setIsOpen] = useState(false)
  const { data: isUsingBigBlocks, isLoading: isLoadingBigBlocks } = useIsUsingBigBlocks()
  const { setIsUsingBigBlocks, isLoading, error, resetError } = useBigBlocksToggle()

  return (
    <DropdownMenu
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open)
        resetError()
      }}
    >
      <DropdownMenuTrigger asChild>
        <SettingsButton />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-[260] mt-2 border border-border-light p-0">
        <div className="px-6 py-4 text-sm">
          <Typography variant="p" className="mb-1 font-bold text-sm">
            Set your preferred block size
          </Typography>
          <Typography variant="prompt">
            For more information, see the{' '}
            <a
              href="https://hyperliquid.gitbook.io/hyperliquid-docs/for-developers/hyperevm/dual-block-architecture"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary underline"
            >
              official documentation
            </a>
            .
          </Typography>

          {!isLoadingBigBlocks && (
            <div className="mt-4">
              <Typography variant="prompt">
                Currently using:
                <span className="ml-0.5 font-bold text-foreground">{isUsingBigBlocks ? 'big' : 'small'} blocks</span>
              </Typography>
            </div>
          )}

          <div className="mt-2 flex items-center gap-2">
            <Button
              className="py-0.5 text-xs"
              size="sm"
              onClick={() => setIsUsingBigBlocks(!isUsingBigBlocks)}
              disabled={isLoading}
            >
              Switch to {isUsingBigBlocks ? 'small' : 'big'} blocks
            </Button>
            {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
          </div>
          {error && <p className="mt-2 text-red-300 text-xs">Failed to set block size</p>}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
